import { Component, Prop } from 'vue-property-decorator';
import { mixins } from 'vue-class-component';
import FieldWrapper from '../field-wrapper/field-wrapper.vue';
import AbstractField from '@/app/modules/shared/components/forms/inputs/abstract-field/abstract-field';
import DatePicker from 'vue2-datepicker';
import 'vue2-datepicker/index.css';
import 'vue2-datepicker/locale/en';
import 'vue2-datepicker/locale/nl';
import 'vue2-datepicker/locale/fr';
import 'vue2-datepicker/locale/es';
import moment from 'moment';

@Component({
  name: 'bpc-datetimepicker',
  components: {
    'bpc-field-wrapper': FieldWrapper,
    'date-picker': DatePicker,
  },
})
export default class DatetimePickertpicker extends mixins(AbstractField) {
  @Prop(String) readonly value: string;
  @Prop(Boolean) readonly showArrows: boolean;
  @Prop({ type: Boolean, default: true }) readonly allowDays: boolean;
  @Prop({ type: Boolean, default: true }) readonly allowWeeks: boolean;

  @Prop({ type: String }) readonly arrowGroupClass: string;
  @Prop({ type: String, default: 'datetime' }) readonly typePicker: string;

  get model(): Date {
    return this.value ? moment(this.value).toDate() : null;
  }

  set model(value) {
    this.$emit('input', value ? moment(value).format('YYYY-MM-DD HH:mm') : null);
    if (this.eventsConfig && this.eventsConfig.emit) {
      this.eventsConfig.emit.forEach(event => {
        this.$root.$emit(event, value);
      });
    }
  }

  get hours(): number[] {
    const start_hour =
      this.$store.getters['centerSettings/centerSettings']?.default_start_hour?.slice(0, 2) || '7';
    const end_hour =
      this.$store.getters['centerSettings/centerSettings']?.default_end_hour?.slice(0, 2) || '22';
    return Array.from({ length: parseInt(end_hour) - parseInt(start_hour) + 1 }).map(
      (_, i) => i + parseInt(start_hour),
    );
  }

  today() {
    const date = moment();
    this.$emit('input', date.format('YYYY-MM-DD HH:mm'));
  }

  prevDay() {
    const date = moment(this.value);
    date.subtract('1', 'd');
    this.$emit('input', date.format('YYYY-MM-DD HH:mm'));
  }

  nextDay() {
    const date = moment(this.value);
    date.add('1', 'd');
    this.$emit('input', date.format('YYYY-MM-DD HH:mm'));
  }

  prevWeek() {
    const date = moment(this.value);
    date.subtract('1', 'w');
    this.$emit('input', date.format('YYYY-MM-DD HH:mm'));
  }

  nextWeek() {
    const date = moment(this.value);
    date.add('1', 'w');
    this.$emit('input', date.format('YYYY-MM-DD HH:mm'));
  }
}
